<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>Stock : วัสดุสิ้นเปลือง</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>
            <v-card flat>
                <Search :branchCode="branchCode" @addClick="dialog = true"></Search>
            </v-card>
        </v-card>
    </v-container>
</template>

<script>

import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
import Search from './Search'


export default {
    name: 'Consumable',
    components: {
        UserBranchDropdown,
        Search
    },
    props:["pageCode"],
    data: () => ({
        branchCode: null
    }),
    methods: {
        setCurrentBranch(branchCode) {
            this.branchCode = branchCode;
        }
    }
}
</script>